import { APICurrentUser, PrivilegeLabel } from '@ardoq/api-types';
import { createStubImplementation } from '@ardoq/stub-implementation';

/**
 * @deprecated prefer `permissionsOperations.hasPrivilege`
 */
export const currentUserHasPrivilege = (
  currentUser: APICurrentUser,
  privilegeLabel: PrivilegeLabel
) => {
  const organization = currentUser.organization;
  if (!organization) return false;
  const privileges = currentUser.privileges[organization._id];
  if (!privileges) return false;
  return privileges.some(({ label }) => label === privilegeLabel);
};

type HasPrivilege = (privilege: PrivilegeLabel) => boolean;

export type PrivilegeInterfaceImplementation = {
  /**
   * @deprecated prefer `permissionsOperations.hasPrivilege`
   */
  hasPrivilege: HasPrivilege;
};

export const defaultImplementation: PrivilegeInterfaceImplementation = {
  hasPrivilege: () => false,
};

export const { hasPrivilege, registerImplementation } =
  createStubImplementation('@ardoq/privileges', defaultImplementation);
